import React from "react"
import { InputGroup, Table } from "react-bootstrap"
import TaskDynamicFormTypes from "src/pages/dynamic_forms/Types/TaskDynamicFormTypes"
import EmployeeDataTypes from "src/pages/hr/Types/EmployeeTypes"
import taskHelper from "../../taskHelper"
import "./TaskDynamicFormOptionsTable.css"

interface Props {
    manageParentState: Function
    taskBoiler: TaskDynamicFormTypes
    taskReference: TaskDynamicFormTypes | any
    employees: Array<EmployeeDataTypes> | []
    distributionGroup: Array<{ id: number, text: string, hashKey: string }>
}

function TaskDynamicFormOptionsTable(props: Props) {

    // console.log("TaskDynamicFormOptionsTable props", props)

    return (
        <div className="TaskDynamicFormOptionsTable">
            {props.distributionGroup.length > 0 && <Table striped bordered hover>
                <tbody>
                    {props.distributionGroup.map((item, i: number) =>
                        <tr id={`task-dynamic-form-options-tr-${i}`} key={`task-dynamic-form-options-item-${i}`} >
                            <td id={`task-dynamic-form-options-td-${i}`}>
                                <div className="TaskDynamicFormOptionsTableItem" onClick={() => {
                                    //??uncomment this to swap the check/uncheck all behavior
                                    // const bucketItem = taskHelper.lookupItem(item.hashKey)[2]
                                    // const allChecked = taskHelper.getDistributionGroup(bucketItem.FormDistributeTo).allChecked
                                    // if (allChecked) {
                                    //     taskHelper.checkOrUncheckAll(bucketItem.FormDistributeTo)
                                    // }
                                    taskHelper.update(item.hashKey, { checked: !taskHelper.isChecked(item.hashKey) })
                                    props.manageParentState([{ key: "tasks", value: taskHelper.getTasks() }])
                                }}>
                                    <InputGroup>
                                        <InputGroup.Checkbox readOnly checked={taskHelper.isChecked(item.hashKey)} />
                                    </InputGroup>
                                    <p>{item.text}</p>
                                </div>
                            </td>
                        </tr>)}
                </tbody>
            </Table>}
            {props.distributionGroup.length === 0 && <div className="TaskDynamicFormOptionsTableNoItems">
                <span className="TaskDynamicFormOptionsTableNoItemsErrEmoji">{`(>_<)`}</span>
                <p>No items found...</p>
            </div>}
        </div >
    )
}

export default TaskDynamicFormOptionsTable